<template>
	<div style="width: 100vw;min-height: 100vh;" :style="{fontFamily:fontFamilyAll}">
		<van-overlay :show="loading" style="background-color: rgb(0 0 0 / 0%);">
			<div style="display: flex;align-items: center;justify-content: center;width: 100%;height: 100%;">
				<van-loading color="#7d7d7d" type="spinner" />
			</div>
		</van-overlay>
		<!-- <div style="height: 30px;width: 100%;"></div> -->

		<div style="width: 100%;height: 100%;" v-if="show"
			:style="designRoute.indexOf($route.name) != -1? getBgStyle(): getBgStyle()">
			<!-- 导航 pc phone -->
			<div style="margin: auto;height: 100%;">
				<div ref="navTop" v-if="equipment == 'pc'" :style="navStyle()" style="width: 100%;margin: auto;">
					<div style="display: flex;justify-content: center;margin: auto;position: relative;" :style="{
						height:navBoxStyle().height,
					}">
						<div :style="{
							...navBoxStyle(),
							...navBgBoxStyle()
						}" style="position: absolute;height: 100%;top: 50%;left: 50%;transform: translate(-50%, -50%);">
						</div>
						<wm-preview :translate_status="translate_status" :translate_list="translate_list"
							:placeNavHeight="placeNavHeight" :boxStyleTwo="navBgBoxStyle()" :boxStyleOne="navBoxStyle()"
							style="overflow: hidden;height: 100%;" typeView="preview" :all_setting="all_setting"
							:po="'top'" :systemConfig="systemConfig" :equipment="equipment"
							:list="navList"></wm-preview>
					</div>
				</div>
				<div ref="phoneNav" v-if="equipment == 'phone'" :style="navStyle()"
					style="width: 100%;background-color: aqua;">
					<wm-preview :translate_status="translate_status" :translate_list="translate_list"
						:placeNavHeight="placeNavHeight" style="width: 100%;" typeView="preview"
						:all_setting="all_setting" :po="'top'" :systemConfig="systemConfig" :equipment="equipment"
						:list="navPhoneList"></wm-preview>
				</div>
			</div>

			<!-- 中间内容区域 -->
			<div style="margin: auto;" v-if="designRoute.indexOf($route.name) != -1">
				<div v-if="centerShow" style="position: relative;width: 100%;">
					<div style="width: 1px;" :style="{height:placeNavHeight + 'px'}"></div>
					<!-- (boxBgheight + placeNavHeight) + 'px' -->
					<div :style="{
						height:'100%',
						...getBoxStyle(),
						...getStyle()
					}" style="position: absolute;z-index: 0;margin: auto;top: 50%;left: 50%;transform: translate(-50%, -50%);"></div>
					<div :style="{
				minHeight:`calc(100vh - ${placeNavHeight + footerHeight}px)` 
			}" style="width: 100%;" ref="designView">
						<div style="max-width: 100%;z-index: 10;position: relative;"
							v-if="$route.path != '/' && breadcrumbsConfig && breadcrumbsConfig.isShow"
							:style="getBreadcrumbStyle(breadcrumbsConfig)">
							<div v-if="equipment == 'pc'"
								style="position: absolute;height: 100%;left: 50%;top: 50%;transform: translate(-50%, -50%);z-index: 1;"
								:style="getBoxBreadcrumbStyle(breadcrumbsConfig)"></div>
							<el-breadcrumb separator="/"
								style="position: relative;z-index: 10;margin: auto;display: flex;" class="ellipsis"
								:style="getBreadcrumbTit(breadcrumbsConfig)">
								<el-breadcrumb-item v-for="(item,index) in breadcrumbs" :key="index"><a
										@click="breadNav(index + 1,item)" @mouseleave="breadcrumbsIndex = -1"
										@mouseenter="breadcrumbsIndex = index" :style="{
											...getBreadcrumbTitColor(breadcrumbsConfig,index)
										}">{{item.meta.id?$t(item.meta.title)+ ':' + item.meta.id:$t(item.meta.title)}}</a></el-breadcrumb-item>
							</el-breadcrumb>
						</div>
						<wm-preview :translate_status="translate_status" :translate_list="translate_list"
							@loadDataComp="loading = true" @noLoadDataComp="loading = false" @changePage="changePage"
							:boxStyleTwo="getBoxStyle()" :boxStyleOne="getStyle()" :all_setting="all_setting"
							typeView="build" :systemConfig="systemConfig" :equipment="equipment"
							:list="centerList"></wm-preview>
					</div>
				</div>
			</div>
			<div style="width: 100%;" :style="{
				minHeight:`calc(100vh - ${placeNavHeight + footerHeight}px)` 
			}" v-if="designRoute.indexOf($route.name) == -1">

				<div style="width: 1px;" :style="{height:placeNavHeight + 'px'}"></div>
				<div style="max-width: 100%;z-index: 10;position: relative;"
					v-if="$route.path != '/' && breadcrumbsConfig && breadcrumbsConfig.isShow"
					:style="getBreadcrumbStyle(breadcrumbsConfig)">
					<div v-if="equipment == 'pc'"
						style="position: absolute;height: 100%;left: 50%;top: 50%;transform: translate(-50%, -50%);z-index: 1;"
						:style="getBoxBreadcrumbStyle(breadcrumbsConfig)"></div>
					<el-breadcrumb separator="/"
						style="position: relative;z-index: 10;margin: auto;display: flex;flex-wrap: nowrap;"
						class="ellipsis" :style="getBreadcrumbTit(breadcrumbsConfig)">
						<el-breadcrumb-item v-for="(item,index) in breadcrumbs" :key="index"><a
								@click="breadNav(index + 1,item)" @mouseleave="breadcrumbsIndex = -1"
								@mouseenter="breadcrumbsIndex = index" :style="{
									...getBreadcrumbTitColor(breadcrumbsConfig,index)
								}">{{getBoxBreadcrumbText(item)}}</a></el-breadcrumb-item>
					</el-breadcrumb>
				</div>
				<!-- 账单页面 -->
				<checkout :placeNavHeight="placeNavHeight" :footerHeight="footerHeight" :boxStyleTwo="getBoxStyle()"
					:boxStyleOne="getStyle()" :equipment="equipment" :localPageData="localPageData"
					v-if="$route.name == 'FrontPage_checkout'">
				</checkout>
				<account :footerHeight="footerHeight" :boxStyleTwo="getBoxStyle()" :boxStyleOne="getStyle()"
					@changeAccount="changeAccount" :equipment="equipment" :localPageData="localPageData"
					v-if="$route.path.startsWith('/account') || $route.path.startsWith('/commission/shop')"></account>
				<login :footerHeight="footerHeight" :boxStyleTwo="getBoxStyle()" :boxStyleOne="getStyle()"
					:placeNavHeight="placeNavHeight" :equipment="equipment" :localPageData="localPageData"
					v-if="$route.name == 'FrontUserLogin'">
				</login>
				<!-- <categories :footerHeight="footerHeight" :boxStyleTwo="getBoxStyle()" :boxStyleOne="getStyle()"
					:placeNavHeight="placeNavHeight" @changePage="changePage" :equipment="equipment"
					:localPageData="localPageData" v-if="$route.path.startsWith('/categories')"></categories> -->
				<carts :footerHeight="footerHeight" :boxStyleTwo="getBoxStyle()" :boxStyleOne="getStyle()"
					:equipment="equipment" :localPageData="localPageData" v-if="$route.path.startsWith('/carts')">
				</carts>
				<order :footerHeight="footerHeight" :boxStyleTwo="getBoxStyle()" :boxStyleOne="getStyle()"
					:placeNavHeight="placeNavHeight" :equipment="equipment" :localPageData="localPageData"
					v-if="$route.name == 'FrontPage_pay'">
				</order>
				<wm-article :footerHeight="footerHeight" :boxStyleTwo="getBoxStyle()" :boxStyleOne="getStyle()"
					:placeNavHeight="placeNavHeight" :equipment="equipment" :localPageData="localPageData"
					v-if="$route.name == 'FrontPage_pages'"></wm-article>
				<page-categories :placeNavHeight="placeNavHeight" :footerHeight="footerHeight"
					:boxStyleTwo="getBoxStyle()" :boxStyleOne="getStyle()" :equipment="equipment"
					:localPageData="localPageData" v-if="$route.name == 'FrontPageCategories'"></page-categories>
				<brands :footerHeight="footerHeight" :boxStyleTwo="getBoxStyle()" :boxStyleOne="getStyle()"
					:placeNavHeight="placeNavHeight" :equipment="equipment" :localPageData="localPageData"
					v-if="$route.name == 'FrontBrandsPage'">
				</brands>
				<brands-goods :footerHeight="footerHeight" :boxStyleTwo="getBoxStyle()" :boxStyleOne="getStyle()"
					:placeNavHeight="placeNavHeight" :equipment="equipment" :localPageData="localPageData"
					v-if="$route.name == 'FrontBrandsId'"></brands-goods>
				<products-search :footerHeight="footerHeight" :boxStyleTwo="getBoxStyle()" :boxStyleOne="getStyle()"
					:placeNavHeight="placeNavHeight" :equipment="equipment" :localPageData="localPageData"
					v-if="$route.name == 'FrontSearch'"></products-search>

				<success-no-login :footerHeight="footerHeight" :boxStyleTwo="getBoxStyle()" :boxStyleOne="getStyle()"
					:placeNavHeight="placeNavHeight" :equipment="equipment" :localPageData="localPageData"
					v-if="$route.name == 'checkoutSuccess'"></success-no-login>
				<search-center :footerHeight="footerHeight" :boxStyleTwo="getBoxStyle()" :boxStyleOne="getStyle()"
					:placeNavHeight="placeNavHeight" :equipment="equipment" :localPageData="localPageData"
					v-if="$route.name == 'FrontSearchCenter'"></search-center>

				<type-products :footerHeight="footerHeight" :boxStyleTwo="getBoxStyle()" :boxStyleOne="getStyle()"
					:placeNavHeight="placeNavHeight" :equipment="equipment" :localPageData="localPageData"
					v-if="$route.name == 'FrontTypeProducts'"></type-products>
			</div>

			<!-- 页脚 pc phone -->
			<div style="margin: auto;height: 100%;width: 100%;" v-if="$route.name != 'FrontPage_pay' && !loading">
				<div v-if="equipment == 'pc'" :style="footStyle()" style="width: 100%;position: relative;">
					<div style="position: absolute;height: 100%;top: 50%;left: 50%;transform: translate(-50%, -50%);z-index:0;"
						:style="{
					...footBgBoxStyle(),
					...footBoxStyle()
					}"></div>
					<div ref="footer" style="margin: auto;">
						<wm-preview :translate_status="translate_status" :translate_list="translate_list"
							:boxStyleTwo="footBgBoxStyle()" :boxStyleOne="footBoxStyle()" :all_setting="all_setting"
							style="overflow: hidden;height: 100%;" typeView="build" :systemConfig="systemConfig"
							:equipment="equipment" :list="footerList"></wm-preview>
					</div>
				</div>
				<div ref="footer" v-if="equipment == 'phone'" :style="footStyle()">

					<!-- <div style="position: absolute;height: 100%;top: 50%;left: 50%;transform: translate(-50%, -50%);z-index:0;"
						:style="{
					...footBgBoxStyle(),
					...footBoxStyle()
					}"></div> -->

					<wm-preview :translate_status="translate_status" :translate_list="translate_list"
						:style="footBgBoxStyle()" typeView="build" :all_setting="all_setting"
						:systemConfig="systemConfig" :equipment="equipment" :list="footerPhoneList"></wm-preview>
				</div>
				<div v-if="($route.name == 'FrontProducts' || $route.name == 'FrontCarts' ||  $route.name == 'FrontPage_checkout') && equipment == 'phone' "
					style="height: 68px;width: 100%;"></div>
			</div>
		</div>
		<global-dialog :systemConfig="systemConfig" :boxStyleOne="{width:'100%'}" v-if="configRequest"
			:configRequest="configRequest" :equipment="equipment" :all_setting="all_setting"></global-dialog>


		<!-- <div v-if="whatsapp == '1'" :style="{
				bottom:equipment == 'pc'?'40px':'20px',
				right:equipment == 'pc'?'40px':'20px',
				
			}" @click="getChart" style="position: fixed;z-index: 1000;cursor: pointer;">
			<img :style="{
				width:equipment == 'pc'?'80px':'50px',
				height:equipment == 'pc'?'80px':'50px'
			}" src="/image/whatspp.png" />
		</div> -->
		<div v-if="service_setting" :style="{
			 ...getChatStyle()
		 }" style="position: fixed;z-index: 10000;">
			<div @click="getChart(item)"
				style="margin-top: 8px;cursor: pointer;display: flex;align-items: center;position: relative;"
				v-for="(item,index) in serviceImgList" :key="index">
				<transition v-if="service_setting.position == 'right'" name="slide-fade">
					<div :style="{
					 right: equipment == 'pc'?(parseInt(service_setting.px) + 5) + 'px':(parseInt(service_setting.px) - 5) + 'px'
				 }" v-if="item.name == 'Phone' && showPhoneEmail"
						style="user-select: text;position: absolute;border: 1px #dddddd;background-color: #fff;color: #000;padding: 4px 6px;border-radius: 4px;border: solid 1px #dddddd;">
						{{item.url}}
					</div>
				</transition>
				<transition v-if="service_setting.position == 'right'" name="slide-fade">
					<div :style="{
					 right: equipment == 'pc'?(parseInt(service_setting.px) + 5) + 'px':(parseInt(service_setting.px) - 5) + 'px'
				 }" v-if="item.name == 'Email' && showPhoneEmail1"
						style="user-select: text;position: absolute;border: 1px #dddddd;background-color: #fff;color: #000;padding: 4px 6px;border-radius: 4px;border: solid 1px #dddddd;">
						{{item.url}}
					</div>
				</transition>


				<transition v-if="service_setting.position == 'left'" name="slide-fade">
					<div :style="{
					 left: equipment == 'pc'?(parseInt(service_setting.px) + 5) + 'px':(parseInt(service_setting.px) - 5) + 'px'
				 }" v-if="item.name == 'Phone' && showPhoneEmail"
						style="user-select: text;position: absolute;border: 1px #dddddd;background-color: #fff;color: #000;padding: 4px 6px;border-radius: 4px;border: solid 1px #dddddd;">
						{{item.url}}
					</div>
				</transition>
				<transition v-if="service_setting.position == 'left'" name="slide-fade">
					<div :style="{
					 left: equipment == 'pc'?(parseInt(service_setting.px) + 5) + 'px':(parseInt(service_setting.px) - 5) + 'px'
				 }" v-if="item.name == 'Email' && showPhoneEmail1"
						style="user-select: text;position: absolute;border: 1px #dddddd;background-color: #fff;color: #000;padding: 4px 6px;border-radius: 4px;border: solid 1px #dddddd;">
						{{item.url}}
					</div>
				</transition>

				<!-- <el-tooltip  v-if="item.name == 'Phone'" class="item" effect="dark" :content="item.url" placement="left">
				    <img :style="{
				    	width:equipment == 'pc'?'60px':'40px',
				    	height:equipment == 'pc'?'60px':'40px'
				    }" :src="item.icon" />
				</el-tooltip>
				
				 <el-tooltip  v-if="item.name == 'Email'" class="item" effect="dark" :content="item.url"  placement="left">
				     <img :style="{
				     	width:equipment == 'pc'?'60px':'40px',
				     	height:equipment == 'pc'?'60px':'40px'
				     }" :src="item.icon" />
				 </el-tooltip> -->

				<img @click.stop.prevent="enterPhoneEmail(item)" :style="{
					width:equipment == 'pc'?service_setting.px + 'px':(parseInt(service_setting.px) - 10) + 'px',
					height:equipment == 'pc'?service_setting.px + 'px':(parseInt(service_setting.px) - 10) + 'px'
				}" :src="item.icon" />
			</div>


			<div @click="toUp"
				style="margin-top: 8px;cursor: pointer;display: flex;align-items: center;position: relative;">
				<div style="border-radius: 100%;background-color: #dddddd;display: flex;align-items: center;justify-content: center;font-weight: bold;"
					:style="{
					width:equipment == 'pc'?service_setting.px + 'px':(parseInt(service_setting.px) - 10) + 'px',
					height:equipment == 'pc'?service_setting.px + 'px':(parseInt(service_setting.px) - 10) + 'px'
				}">
					<i :style="{
						fontSize:equipment == 'pc'?(service_setting.px - 15) + 'px':parseInt(service_setting.px - 15) + 'px'
					}" class="el-icon-top"></i>
				</div>
			</div>


		</div>



	</div>
</template>
<script>
	import globalDialog from './globalDialog.vue'
	import {
		getSetting,
		getShow,
		getAccountCollect,
		getCheckoutData,
		getZones,
		getcheckoutAddress,
		getWhatsapp_chat
	} from '../../api/all.js'
	import apiConfig from '../config/apiConfig.js'
	import {
		mapState,
		mapGetters,
		mapActions,
		mapMutations
	} from 'vuex';
	import wmPreview from '../components/preview.vue'
	import categories from './views/categories.vue'
	import checkout from './views/checkout.vue'
	import account from './views/account.vue'
	import order from './views/order.vue'
	import carts from './views/carts.vue'
	import wmArticle from './views/article.vue'
	import pageCategories from './views/page_categories.vue'
	import brands from './views/brands.vue'
	import brandsGoods from './views/brandsGoods.vue'
	import productsSearch from './views/productsSearch.vue'
	import successNoLogin from './views/successNoLogin.vue'
	import searchCenter from './views/searchCenter.vue'
	import login from './views/login.vue'
	import config from '../config.js'
	import typeProducts from './views/typeProducts.vue'
	import facebookPixel from '../../facebookPixel'


	export default {
		components: {
			globalDialog,
			successNoLogin,
			wmPreview,
			checkout,
			account,
			login,
			categories,
			carts,
			order,
			wmArticle,
			pageCategories,
			brands,
			brandsGoods,
			productsSearch,
			searchCenter,
			typeProducts
		},
		computed: {},
		data() {
			return {
				service_setting: null,

				serviceImgList: [],
				translate_status: "0",
				translate_list: [],
				configRequest: null,
				footerHeight: 0,
				breadcrumbsIndex: -1,
				boxBgheight: 0,
				breadcrumbs: [{
					path: "/",
					meta: {
						title: "h.home",
					},
				}],
				centerShow: false,
				isReload: true,
				designRoute: ['FrontProducts', 'FrontPreview', 'FrontCategories'],
				localPageData: {},
				placeNavHeight: 0,
				show: false,
				loading: false,
				systemConfig: {}, // 系统设置
				equipment: 'pc',
				all_setting: [], // 全局设置
				config,
				navList: [], // 导航
				navPhoneList: [], // 手机导航
				footerList: [],
				footerPhoneList: [],
				centerList: [],
				resizeObserver: null,
				whatsapp: "0",
				langTime: null,
				langTime1: null,
				langTime2: null,
				langTime3: null,
				showPhoneEmail: false,
				showPhoneEmail1: false
			}
		},
		watch: {
			$route: {
				deep: true,
				handler: async function(to, from) {
					// 最多三个 已经存在一个
					console.log('to, from', to, from)
					if (to.path != '/') {

						if (this.breadcrumbs.length == 3) {
							this.breadcrumbs.splice(2, 1)
						}
						if (to.params && to.params.id) {
							this.breadcrumbs.push({
								path: to.path,
								meta: {
									...to.meta,
									id: to.params.id
								},

							})
						} else {
							this.breadcrumbs.push({
								path: to.path,
								meta: {
									...to.meta,
									id: to.params.id
								},
							})
						}

					} else {
						this.breadcrumbs = [{
							path: "/",
							meta: {
								title: "h.home",
							},
						}]
					}


					document.documentElement.scrollTop = 0;
					window.pageYOffset = 0; // 兼容ios
					document.body.scrollTop = 0; // 兼容低版本ie
					this.judgeEquipment() // 判断设备
					this.show = true
					this.loading = false

					if (this.isReload) {
						await this.loadRouterData(to)
					} else {
						this.isReload = true
					}
				}
			}
		},
		computed: {
			...mapState("lowCodeStore", ['goodsConfig', 'systemLanguage', 'selectLanguage']),
			breadcrumbsConfig: function() {
				if (this.all_setting.length > 0) {
					return this.all_setting[0].tabList[2].config.breadcrumb
				} else {
					return null
				}
			},
			fontList: function() {
				if (this.all_setting.length > 0) {
					let itemSetFont = this.all_setting[0].tabList[1]
					return itemSetFont.config.setfontFamily.fontList
				}
			},
			fontFamilyAll: function() {
				if (this.all_setting.length > 0) {
					this.getFontStyle(this.all_setting[0].tabList[1].config.setfontFamily.fontFamily)
					// console.log('this.all_setting[0].tabList[1].config.setfontFamily',this.all_setting[0].tabList[1].config.setfontFamily)
					return this.all_setting[0].tabList[1].config.setfontFamily.fontFamily
				} else {
					return ''
				}
			}
		},
		async mounted() {
			let that = this
			const systemLanguage = navigator.language || navigator.userLanguage;

			this.setList({
				filed: "systemLanguage",
				list: systemLanguage
			})
			if (!this.$cookies.get('googtrans')) {
				document.cookie = `googtrans=/auto/${systemLanguage}`;
				window.location.reload()
				return
			}
			if (this.$cookies.get('googtrans')) {
				// if (this.$cookies.get('googtrans').indexOf(systemLanguage) == -1) {
				// 	document.cookie = `googtrans=/auto/${systemLanguage}`;
				// 	window.location.reload()
				// }
			}



			// this.insertScriptBeforeBody(`<script src="https://plugin-code.salesmartly.com/js/project_359102_368971_1749807375.js"><\/script>`)


			// this.changeFavicon('/path/to/new-favicon.ico');


			if (this.$route.path != '/') {
				if (this.$route.params && this.$route.params.id) {
					this.breadcrumbs.push({
						path: this.$route.path,
						meta: {
							...this.$route.meta,
							id: this.$route.params.id
						}
					})
				} else {
					this.breadcrumbs.push({
						path: this.$route.path,
						meta: {
							...this.$route.meta,
							id: this.$route.params.id
						}
					})
				}

			}

			localStorage.setItem('loadConfig', '')
			this.judgeEquipment() // 判断设备
			this.show = true
			this.loading = false
			await this.loadRouterData(this.$route)
			// facebookPixel.track('PageView', {
			// 	 eventID: 'unique_event_id_' + Date.now() // 使用时间戳或其他唯一ID
			// });
			// 使用 trackCustom 方法创建自定义事件
			// facebookPixel.trackCustom('PageViewCurrent', {
			//   page:this.$route.path
			// });

			if (this.translate_status == '2' || this.translate_status == '1') {
				let isLangHaveNav = false
				if (this.equipment == 'pc') {

					this.navList.forEach(item => {
						item.children.forEach(childItem => {
							childItem.children.forEach(twoChildItem => {
								if (twoChildItem.compontChildren && twoChildItem
									.compontChildren.length > 0) {
									if (twoChildItem.compontChildren[0].compoentName ==
										'wmLangMoney') {
										isLangHaveNav = true
									}
								}
							})
						})
					})
					if (!isLangHaveNav) {
						this.footerList.forEach(item => {
							item.children.forEach(childItem => {
								childItem.children.forEach(twoChildItem => {
									if (twoChildItem.compontChildren && twoChildItem
										.compontChildren.length > 0) {
										if (twoChildItem.compontChildren[0].compoentName ==
											'wmLangMoney') {
											isLangHaveNav = true
										}
									}
								})
							})
						})
					}

				} else {

					this.navPhoneList.forEach(item => {
						item.children.forEach(childItem => {
							childItem.children.forEach(twoChildItem => {
								if (twoChildItem.compontChildren && twoChildItem
									.compontChildren.length > 0) {
									if (twoChildItem.compontChildren[0].compoentName ==
										'wmLangMoney') {
										isLangHaveNav = true
									}
								}
							})
						})
					})
					if (!isLangHaveNav) {
						this.footerPhoneList.forEach(item => {
							item.children.forEach(childItem => {
								childItem.children.forEach(twoChildItem => {
									if (twoChildItem.compontChildren && twoChildItem
										.compontChildren.length > 0) {
										if (twoChildItem.compontChildren[0].compoentName ==
											'wmLangMoney') {
											isLangHaveNav = true
										}
									}
								})
							})
						})
					}

				}


				if (!isLangHaveNav) {

					this.centerList.forEach(item => {
						item.children.forEach(childItem => {
							childItem.children.forEach(twoChildItem => {
								if (twoChildItem.compontChildren && twoChildItem
									.compontChildren.length > 0) {
									if (twoChildItem.compontChildren[0].compoentName ==
										'wmLangMoney') {
										isLangHaveNav = true
									}
								}

							})
						})
					})

				}


				if (isLangHaveNav) {
					this.langTime = setInterval(() => {
						if (document.getElementById(':1.container')) {
							const body1 = document.body;
							document.getElementById(':1.container').style.display = 'none'
							clearInterval(that.langTime)
						}

						// console.log(1)
					}, 0)


					this.langTime3 = setInterval(() => {
						if (document.getElementById(':1.container')) {
							const body1 = document.body;
							if (body1.style.top == '40px') {
								body1.style.top = '0px'
								console.log(body1.style.top)
								clearInterval(that.langTime3)
							}
						}
						// console.log(4)
					}, 0)



					this.langTime1 = setInterval(() => {
						if (document.getElementById("goog-gt-tt")) {
							document.getElementById("goog-gt-tt").remove()
							clearInterval(that.langTime1)
						}
						console.log(2)
					}, 0)

					this.langTime2 = setInterval(() => {
						if (document.querySelector(".VIpgJd-ZVi9od-aZ2wEe-wOHMyf")) {
							document.querySelector(".VIpgJd-ZVi9od-aZ2wEe-wOHMyf").remove()
							clearInterval(that.langTime2)
						}
						console.log(3)
					}, 0)
				}
			}




			// if(this.translate_status != '0'){
			// 	if (this.$cookies.get('googtrans')) {
			// 		if (this.$cookies.get('googtrans').indexOf(systemLanguage) == -1) {
			// 			document.cookie = `googtrans=/auto/${systemLanguage}`;
			// 			// window.location.reload()
			// 		}
			// 	}
			// 	if(this.translate_status == '1'){
			// 		document.cookie = `googtrans=/auto/${systemLanguage}`;
			// 	}
			// }
		},
		updated() {
			if (this.equipment == 'pc') {
				if (this.$refs.navTop && this.all_setting.length > 0) {
					let setItem = this.all_setting[0].tabList[0].config.nav
					if (setItem.navSetHeight.toTop) {
						this.placeNavHeight = this.$refs.navTop.offsetHeight
						console.log('this.placeNavHeight', this.placeNavHeight)
					}
				}
				if (this.$refs.designView) {
					this.boxBgheight = this.$refs.designView.offsetHeight
				}
				if (this.$refs.footer) {
					this.footerHeight = this.$refs.footer.offsetHeight
				}
			} else {
				let that = this
				if (this.$refs.footer) {
					this.footerHeight = this.$refs.footer.offsetHeight
				}
				if (this.$refs.phoneNav && that.all_setting.length > 0) {
					let setItem = this.all_setting[0].tabList[0].config.nav
					if (setItem.navSetHeight.toTop) {
						setTimeout(() => {
							that.placeNavHeight = that.$refs.phoneNav.getBoundingClientRect().height
							console.log('that.placeNavHeight', that.placeNavHeight)
						}, 120)
					}
				}
			}
		},
		methods: {
			toUp() {
				window.scrollTo({
					top: 0,
					behavior: "smooth",
				});
			},

			appendCode() {
				if (this.all_setting.length > 0) {
					// console.log('this.all_setting', this.all_setting)
					if (this.all_setting[0].tabList[4]) {
						if (this.all_setting[0].tabList[4].config.bodyTopCode) {
							this.insertScriptBeforeBody(this.all_setting[0].tabList[4].config.bodyTopCode)
						}

						if (this.all_setting[0].tabList[4].config.headCode) {
							this.insertIntoHead(this.all_setting[0].tabList[4].config.headCode)
						}
					}
				}
			},
			appendCodeMeta_pixel(meta_pixel) {
				console.log('meta_pixel', meta_pixel)
				this.insertIntoHead(meta_pixel)
				// fbq('track', 'PageView', {
				//     page_path: '/'
				//   });
				
			},


			insertIntoHead(htmlString) {
				// 1. 用 DOMParser 解析字符串，提取所有合法 head 标签
				const doc = new DOMParser().parseFromString(htmlString, 'text/html');

				// 2. 遍历所有可插入 head 的标签类型
				const tags = doc.head.querySelectorAll(`
			    script, link, meta, style, title, base, noscript, template
			  `);

				// 3. 克隆每个标签并插入到当前文档的 <head>
				tags.forEach(tag => {
					const newTag = document.createElement(tag.tagName.toLowerCase());

					// 复制所有属性（包括 src, href, async, defer, crossorigin 等）
					Array.from(tag.attributes).forEach(attr => {
						newTag.setAttribute(attr.name, attr.value);
					});

					// 特殊处理：<style> 和 <script> 需要复制内容
					if (tag.tagName === 'STYLE' || (tag.tagName === 'SCRIPT' && !tag.src)) {
						newTag.textContent = tag.textContent;
					}

					// 插入到当前文档的 <head>
					document.head.appendChild(newTag);
				});
			},

			insertScriptBeforeBody(jsCodeString) {
				// 1. 使用 DOMParser 解析字符串（处理多个 <script> 或混合 HTML）
				const parser = new DOMParser();
				const doc = parser.parseFromString(jsCodeString, 'text/html');

				// 2. 获取所有 <script> 标签
				const scripts = doc.querySelectorAll('script');

				// 3. 遍历并动态插入每一个 <script>
				scripts.forEach(script => {
					const newScript = document.createElement('script');

					// 复制原 <script> 的属性（如 src, async, defer 等）
					Array.from(script.attributes).forEach(attr => {
						newScript.setAttribute(attr.name, attr.value);
					});

					// 设置 JS 代码内容（如果是内联脚本）
					if (script.src) {
						// 如果是外部脚本，直接设置 src
						newScript.src = script.src;
					} else {
						newScript.textContent = script.textContent;
					}

					// 插入到 <body> 前
					document.body.parentNode.insertBefore(newScript, document.body);
				});
			},

			enterPhoneEmail(item) {

				if (item.name == 'Phone') {
					this.showPhoneEmail = !this.showPhoneEmail
					return
				}
				if (item.name == 'Email') {
					this.showPhoneEmail1 = !this.showPhoneEmail1
					return
				}
				window.open(item.url)
			},
			getChatStyle() {
				let style = {}
				style.bottom = this.service_setting.down + 'px'
				if (this.service_setting.position == 'right') {
					style.right = this.service_setting.right + 'px'
				} else {
					style.left = this.service_setting.left + 'px'
				}
				return style
			},
			async getChart(item) {
				if (item.name == 'Phone') {
					return
				}
				if (item.name == 'Email') {
					return
				}
				window.open(item.url)
				// try {
				// 	this.loading = true
				// 	const data = await getWhatsapp_chat()
				// 	console.log('datadatadata', data)
				// 	window.open(data.data)
				// 	this.loading = false
				// } catch (e) {
				// 	this.loading = false
				// }

			},
			...mapMutations("lowCodeStore", ["setSelectdItem", "setCenterList", "setList"]),

			// 获取当前页面的favicon链接
			getFavicon() {
				return document.querySelector("link[rel*='icon']");
			},

			// 修改favicon
			changeFavicon(src) {
				const favicon = this.getFavicon();
				if (favicon) {
					favicon.href = src;
				} else {
					console.log('changeFaviconchangeFavicon', src)

					const link = document.createElement('link');
					link.rel = 'icon';
					link.href = src;
					document.head.appendChild(link);
				}
			},
			getFontStyle(e) {
				let item;
				console.log('getFontStyle', this.fontList)
				this.fontList.forEach(fontItem => {
					if (fontItem.name == e) {
						item = fontItem
					}
				})
				console.log('getFontStyleitem', item)
				console.log('getFontStyleitem', e)
				if (item) {
					if (!document.getElementById(item.name)) {
						var style = document.createElement('style');
						style.type = 'text/css';
						style.id = item.name
						style.innerHTML = item.css;
						document.getElementsByTagName('HEAD').item(0).appendChild(style);
					}
				}
			},
			getBoxBreadcrumbText(item) {
				if (item.meta.id == 'hot') {
					return this.$t('h.hotGoods')
				}
				if (item.meta.id == 'new') {
					return this.$t('h.newGoods')
				}
				if (item.meta.id == 'visit') {
					return this.$t('h.visitGoods')
				}
				if (item.meta.id == 'all') {
					return this.$t('h.allGoods')
				}

				return item.meta.id ? this.$t(item.meta.title) + `${this.$t(item.meta.title)?':':''}` + item
					.meta.id : this
					.$t(item.meta.title)
			},
			getBreadcrumbTitColor(config, index) {
				let style = {}

				// 字体
				style.fontSize = config.fontSize + 'px'
				style.fontFamily = config.fontFamily

				if ((this.breadcrumbs.length - 1) == index) {
					style.color = config.currentColor
				} else {
					console.log('this.breadcrumbsIndex', this.breadcrumbsIndex)
					if (this.breadcrumbsIndex != -1 && config.hoverColor && this.breadcrumbsIndex == index) {

						style.color = config.hoverColor
					} else {
						style.color = config.color
					}

				}
				return style
			},
			getBreadcrumbTit(config) {
				let style = {}
				if (config.titPosition == 'center') {
					style.justifyContent = config.titPosition
				} else {
					style.justifyContent = "flex-" + config.titPosition
				}
				if (config.titType == 'box' && this.equipment == 'pc') {
					style.width = config.titBoxWidth + 'px'
				} else {
					style.width = '100%'
				}
				console.log('getBreadcrumbTitgetBreadcrumbTit', config)
				return style
			},
			getBoxBreadcrumbStyle(config) {
				let style = {}
				if (config.type == 'box') {
					style.width = config.typeBoxWidth + 'px'
					if (config.boxBgColor == 'color') {
						style.backgroundColor = config.boxColor
					}
					if (config.boxBgColor == 'gradient') {
						style = {
							...style,
							...this.cssStringToObject(config.boxGradient)
						}
					}
				}
				return style
			},
			getBreadcrumbStyle(config) {

				let style = {}
				if (config.bgType == 'color') {
					style.backgroundColor = config.bgColor
				}
				if (config.bgType == 'gradient') {
					style = {
						...style,
						...this.cssStringToObject(config.bgGradient)
					}
				}

				// 内外边距
				console.log('getBreadcrumbStyleconfig', config)
				style.paddingTop = config.padding[0] + 'px'
				style.paddingLeft = config.padding[2] + 'px'
				style.paddingBottom = config.padding[1] + 'px'
				style.paddingRight = config.padding[3] + 'px'

				style.marginTop = config.margin[0] + 'px'
				style.marginLeft = config.margin[2] + 'px'
				style.marginBottom = config.margin[1] + 'px'
				style.marginRight = config.margin[3] + 'px'

				// 线条圆角

				if (config.border.type && config.border.color) {
					style.borderTop =
						`${config.border.type} ${config.border.borderSize[0]}px ${config.border.color}`
					style.borderLeft =
						`${config.border.type} ${config.border.borderSize[1]}px ${config.border.color}`
					style.borderBottom =
						`${config.border.type} ${config.border.borderSize[2]}px ${config.border.color}`
					style.borderRight =
						`${config.border.type} ${config.border.borderSize[3]}px ${config.border.color}`
					console.log('getBorderstyle', style)
				}

				style.borderRadius =
					`${config.border.borderRadius[0]}px ${config.border.borderRadius[1]}px ${config.border.borderRadius[2]}px ${config.border.borderRadius[3]}px`


				return style
			},
			breadNav(l) {
				console.log(this.$route.matched.filter(route => route.meta.breadcrumb))
				console.log('breadNav', this.$route)
				console.log('breadNav', this.$router)
				if (l == 1) {
					this.$router.replace({
						path: '/'
					})
				}
				if (l == 2) {
					if (this.breadcrumbs.length == 2) {
						return
					}
					if (this.breadcrumbs.length > 1) {
						this.breadcrumbs = [{
							path: "/",
							meta: {
								title: "h.home",
							},
						}]
						this.$router.go(-1)
					}
				}
			},
			changePage(e) {
				this.isReload = false
				this.$router.replace({
					path: e,
				})
			},
			changeAccount(e) {
				this.isReload = false
				this.$router.replace({
					path: e,
				})
			},
			// 获取数据
			async getData() {
				// 获取数据
				let wsid = this.$cookies.get("wsid")
				// 获取页面配置 全局配置
				let config = await getSetting({
					wsid
				})

				this.translate_status = config.data.data.translate_status
				this.translate_list = config.data.data.translate_list
				this.whatsapp = config.data.data.whatsapp
				this.serviceImgList = config.data.data.service
				this.service_setting = config.data.data.service_setting
				if (config.data.data.list.goodsConfig) {
					console.log('JSON.parse(showData.data.data.list.goodsConfig)', JSON.parse(config.data
						.data.list
						.goodsConfig))
					this.setList({
						filed: 'goodsConfig',
						list: JSON.parse(config.data.data.list.goodsConfig)
					})
				}




				if (config.data.data.list.classifyList) {
					this.setList({
						filed: 'classifyListPreview',
						list: JSON.parse(config.data.data.list.classifyList)
					})
				}


				// console.log('configconfigconfig',config.data.data.list.pcNav)
				this.changeFavicon(config.data.data.favicon);
				this.configRequest = config
				if (config.data.data.all_setting) {
					// 全局配置
					this.all_setting = JSON.parse(config.data.data.all_setting.data)
					this.appendCode()
				}
				if (config.data.data.meta_pixel) {
					this.appendCodeMeta_pixel(config.data.data.meta_pixel)
				}
				// 获取系统配置 语言货币
				// let setData = await getSetting({})
				localStorage.setItem("locale", config.data.data.locale);
				this.$i18n.locale = localStorage.getItem("locale");
				console.log('config', localStorage.getItem("locale"))
				this.systemConfig = config.data.data
			},
			// 获取字段
			getField(type) {
				let filed = 'navList'
				this.config.center.page.forEach(pageItem => {
					if (pageItem.type == type) {
						filed = pageItem.filed
					}
				})
				return filed
			},
			async loadRouterData(to) {
				try {
					if (!this.loading) {
						this.loading = true
					}
					if (localStorage.getItem('loadConfig') != 'load') {
						this.show = false
						await this.getData() // 获取数据
					}
					if (localStorage.getItem('loadConfig') != 'load' || this.designRoute.indexOf(this
							.$route.name) != -
						1) {
						this.centerShow = false
						await this.requestFun({
							menu: this.configRequest.data.data.menu,
							footer: this.configRequest.data.data.footer,
						}, this.$route.path, to)
						localStorage.setItem('loadConfig', 'load')
					}
					this.show = true
					this.loading = false
					this.centerShow = true

				} catch (e) {
					console.log('e', e)
					this.loading = false
				}

			},

			// 判断设备
			judgeEquipment() {
				if (window.innerWidth > 1200) {
					// 当前设备是移动设备 
					this.equipment = 'pc'
				} else {
					this.equipment = 'phone'
				}
			},

			getCookie(cname) {
				var name = cname + "=";
				var ca = document.cookie.split(';');
				for (var i = 0; i < ca.length; i++) {
					var c = ca[i].trim();
					if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
				}
				return "";
			},

			// 重新装配 导航
			async requestFun(obj, path, to) {
				console.log('path', path)
				console.log(path.indexOf('products'))
				// 获取页面配置对应的键值对
				let pageType = 'home'
				if (path == '/') {
					pageType = 'home'
				}
				if (this.$route.name == 'FrontProducts') {
					pageType = 'detail'
				}

				if (this.$route.name == 'FrontCategories') {
					pageType = 'classifyList'
				}

				console.log('pageType', pageType)
				// 获取当前导航 和 页面配置
				if (this.configRequest.data.data.list) {
					// 页面配置
					let listObj = this.configRequest.data.data.list
					for (let i in listObj) {
						if (i != 'goodsConfig') {
							let field = this.getField(i)
							if (i == pageType) {
								this['centerList'] = JSON.parse(listObj[i])
							} else {
								if (i != 'bottomCartPhone') {
									this[field] = JSON.parse(listObj[i])
								}
							}
						}
					}
				}
				if (this.designRoute.indexOf(this.$route.name) != -1) {
					await this.requestInitData('centerList', obj, to)
				}
				if (localStorage.getItem('loadConfig') != 'load') {
					if (this.equipment == 'pc') {
						await this.requestInitData('navList', obj, to)
						console.log('objobjobj', obj)
						await this.requestInitData("footerList", obj, to)

						console.log('footerListfooterList', this.footerList)
						console.log('navListnavListnavList', this.navList)
					} else {

						console.log('footerPhoneListfooterPhoneList', this.footerPhoneList)

						await this.requestInitData("footerPhoneList", obj, to)
						await this.requestInitData("navPhoneList", obj, to)
					}
				}
			},
			// 重新装配 导航
			async requestInitData(fieldList, obj, to) {
				let that = this
				for (let i = 0; i < this[fieldList].length; i++) {
					let item = this[fieldList][i]

					console.log('requestInitData item', item)
					if (item.requestFun) {
						for (let j = 0; j < item.children.length; j++) {
							let childrenItem = item.children[j]
							for (let k = 0; k < childrenItem.children.length; k++) {
								let twoChildrenItem = childrenItem.children[k]
								for (let m = 0; m < twoChildrenItem.compontChildren
									.length; m++) {
									let compontChildrenItem = twoChildrenItem.compontChildren[
										m]
									console.log('compontChildrenItem', compontChildrenItem)
									console.log('obj', obj)
									await that.initData(compontChildrenItem, obj, to, childrenItem, twoChildrenItem,
										item)
								}
							}
						}
					}
				}
			},
			async initData(compoent, obj, to, childrenItem, twoChildrenItem, item) {
				// this.loading = true
				let that = this
				try {
					let name = compoent.compoentName
					for (let i = 0; i < apiConfig.length; i++) {
						let fun = apiConfig[i]
						console.log('fun', fun)
						if (fun[name]) {
							if (compoent.requestFun) {
								console.log('compoent', name)
								console.log('apiConfig', apiConfig)
								for (let j = 0; j < compoent.requestFun.length; j++) {
									let funName = compoent.requestFun[j]
									let data = await fun[name]['requestData'][funName](
										that, 'build', {
											classfiy: compoent.data,
											data: compoent,
											list: obj,
											childrenItem,
											twoChildrenItem,
											item
										}, to)
									console.log('initData', data)
								}
							}
						}
					}
					// this.loading = false
				} catch (e) {
					console.log('e', e)
					this.loading = false
				}
			},

			// style
			getBgStyle() {
				if (this.$route.path.indexOf('/checkout') != -1) {
					return
				}


				try {
					if (this.all_setting.length > 0) {
						let setItem = this.all_setting[0].tabList[0].config
						let style = {}
						if (setItem.bg.bgType == 'checked1') {
							style.background = setItem.bg.singleBgColor.bgColor
						}
						if (setItem.bg.bgType == 'checked2') {
							return setItem.bg.bgColor.bgColor
						}
						if (setItem.bg.bgType == 'checked3') {
							let backgroundImage = `url(${setItem.bg.bgImg.url})`
							if (setItem.bg.bgImg.width) {
								style.backgroundSize = setItem.bg.bgImg.width + 'px';
							} else {
								style.backgroundSize = '100%';
							}
							if (setItem.bg.bgImg.height) {
								style.backgroundSize = style.backgroundSize + ' ' + (
									setItem.bg.bgImg.height +
									'px')
							} else {
								style.backgroundSize = style.backgroundSize + ' 100%'
							}
							if (setItem.bg.bgImg.type) {
								style.backgroundRepeat = setItem.bg.bgImg.type
							}
							if (setItem.bg.bgImg.position) {
								style.backgroundPosition = setItem.bg.bgImg.position
							}
							style.backgroundImage = backgroundImage
						}
						return style
					}
				} catch (e) {

				}
			},
			getStyle() {
				try {
					if (this.equipment == 'phone') {
						return {}
						// console.log('this.$refs.phoneNav',this.$refs.phoneNav)

						// let style = {}
						// let setItem = this.all_setting[0].tabList[0].config
						// if (this.equipment == 'phone' && (this.$route.path.indexOf('/checkout') != -1 || this.$route.path
						// 		.indexOf('/carts') != -1)) {
						// 	let height = setItem.nav.navSetHeight.height
						// 	console.log('setItem.nav.navSetHeight.height', setItem.nav.navSetHeight.height)
						// 	style.height = `calc(100vh - ${height}px)`
						// }
						// return style
					}
					if (this.all_setting.length > 0) {
						let setItem = this.all_setting[0].tabList[0].config
						let style = {}
						if (setItem.bg.setWidth.type == 'px') {
							style.width = setItem.bg.setWidth.width + 'px'
						} else {
							style.width = "100%"
						}
						return style
					}
				} catch (e) {

				}
			},
			getBoxStyle() {
				try {
					if (this.all_setting.length > 0) {
						let setItem = this.all_setting[0].tabList[0].config
						console.log('setItemsetItem', setItem)
						let style = {}
						if (setItem.bg.setWidth.type == 'px') {
							if (setItem.box.bgType == 'checked1') {
								style.background = setItem.box.boxSingleBgColor.bgColor
							}
							if (setItem.box.bgType == 'checked2') {
								style = {
									...style,
									...this.cssStringToObject(setItem.box.boxColor
										.bgColor)
								}

								// return 
							}

							if (setItem.box.bgType == 'checked3') {
								let backgroundImage = `url(${setItem.box.boxBgImg.url})`
								if (setItem.box.boxBgImg.width) {
									style.backgroundSize = setItem.box.boxBgImg.width +
										'px';
								} else {
									style.backgroundSize = '100%';
								}
								if (setItem.box.boxBgImg.height) {
									style.backgroundSize = style.backgroundSize + ' ' + (
										setItem.box.boxBgImg.height +
										'px')
								} else {
									style.backgroundSize = style.backgroundSize + ' 100%'
								}
								if (setItem.box.boxBgImg.type) {
									style.backgroundRepeat = setItem.box.boxBgImg.type
								}
								if (setItem.box.boxBgImg.position) {
									style.backgroundPosition = setItem.box.boxBgImg
										.position
								}
								style.backgroundImage = backgroundImage
							}
						}
						console.log('setItemsetItemstyle', style)
						return style
					}
				} catch (e) {}
			},
			navStyle() {
				try {
					if (this.all_setting.length > 0) {
						let setItem = this.all_setting[0].tabList[0].config.nav
						let style = {}

						if (setItem.navSetHeight.toTop) {
							// position: fixed;top: 0px;z-index: 1000;
							style.position = 'fixed'
							style.top = '0px'
							style.zIndex = 1200
							console.log('navStyle', style)
						}

						if (setItem.bg.bgType == 'checked1') {
							style.background = setItem.bg.singleBgColor.bgColor
						}
						if (setItem.bg.bgType == 'checked2') {
							let str = ''
							if (setItem.navSetHeight.toTop) {
								// position: fixed;top: 0px;z-index: 1000;
								str = "position:fixed;top:0px;zIndex:1000;"
								// style.position = 'fixed'
								// style.top = '0px'
								// style.zIndex = 1000
								console.log('navStyle', style)
							}
							return str + setItem.bg.bgColor.bgColor
						}
						if (setItem.bg.bgType == 'checked3') {
							let backgroundImage = `url(${setItem.bg.bgImg.url})`
							if (setItem.bg.bgImg.width) {
								style.backgroundSize = setItem.bg.bgImg.width + 'px';
							} else {
								style.backgroundSize = '100%';
							}
							if (setItem.bg.bgImg.height) {
								style.backgroundSize = style.backgroundSize + ' ' + (
									setItem.bg.bgImg.height + 'px')
							} else {
								style.backgroundSize = style.backgroundSize + ' 100%'
							}
							if (setItem.bg.bgImg.type) {
								style.backgroundRepeat = setItem.bg.bgImg.type
							}
							if (setItem.bg.bgImg.position) {
								style.backgroundPosition = setItem.bg.bgImg.position
							}
							style.backgroundImage = backgroundImage
						}

						if (this.equipment == 'phone') {
							if (setItem.btoShadow.bgColor) {
								style.boxShadow =
									`0px -${setItem.btoShadow.y}px ${setItem.btoShadow.r}px ${setItem.btoShadow.bgColor} inset`
							}
						}

						return style
					}
				} catch (e) {
					console.log('e', e)
				}
			},
			navBoxStyle() {
				if (this.equipment == 'phone') {

					return {}
				}
				try {
					if (this.all_setting.length > 0) {
						let setItem = this.all_setting[0].tabList[0].config.nav
						let style = {}
						if (setItem.bg.setWidth.type == 'px') {
							style.width = setItem.bg.setWidth.width + 'px'
						} else {
							style.width = "100%"
						}
						if (setItem.navSetHeight.height) {
							console.log('navBoxStyle.navSetHeight.height', setItem
								.navSetHeight.height)
							// style.height = setItem.navSetHeight.height + 'px'
							style.height = "100%"
						} else {
							style.height = "100%"
						}


						if (setItem.btoShadow.bgColor) {
							style.boxShadow =
								`0px -${setItem.btoShadow.y}px ${setItem.btoShadow.r}px ${setItem.btoShadow.bgColor} inset`
						}
						return style
					}
				} catch (e) {
					console.log('e', e)
				}
			},
			navBgBoxStyle() {
				try {
					if (this.all_setting.length > 0) {
						let setItem = this.all_setting[0].tabList[0].config.nav
						let style = {}
						if (setItem.bg.setWidth.type == 'px') {
							if (setItem.box.bgType == 'checked1') {
								style.background = setItem.box.boxSingleBgColor.bgColor
							}
							if (setItem.box.bgType == 'checked2') {
								style = {
									...style,
									...this.cssStringToObject(setItem.box.boxColor
										.bgColor)
								}
								// return 
								// return setItem.box.boxColor.bgColor
							}
							if (setItem.box.bgType == 'checked3') {
								let backgroundImage = `url(${setItem.box.boxBgImg.url})`
								if (setItem.box.boxBgImg.width) {
									style.backgroundSize = setItem.box.boxBgImg.width +
										'px';
								} else {
									style.backgroundSize = '100%';
								}
								if (setItem.box.boxBgImg.height) {
									style.backgroundSize = style.backgroundSize + ' ' + (
										setItem.box.boxBgImg.height +
										'px')
								} else {
									style.backgroundSize = style.backgroundSize + ' 100%'
								}
								if (setItem.box.boxBgImg.type) {
									style.backgroundRepeat = setItem.box.boxBgImg.type
								}
								if (setItem.box.boxBgImg.position) {
									style.backgroundPosition = setItem.box.boxBgImg
										.position
								}
								style.backgroundImage = backgroundImage
							}
						}
						return style
					}
				} catch (e) {
					console.log('e', e)
				}
			},
			footStyle() {
				try {
					if (this.all_setting.length > 0) {
						let setItem = this.all_setting[0].tabList[0].config.foot
						let style = {}
						if (setItem.bg.bgType == 'checked1') {
							style.background = setItem.bg.singleBgColor.bgColor
						}
						if (setItem.bg.bgType == 'checked2') {
							return setItem.bg.bgColor.bgColor
						}
						if (setItem.bg.bgType == 'checked3') {
							let backgroundImage = `url(${setItem.bg.bgImg.url})`
							if (setItem.bg.bgImg.width) {
								style.backgroundSize = setItem.bg.bgImg.width + 'px';
							} else {
								style.backgroundSize = '100%';
							}
							if (setItem.bg.bgImg.height) {
								style.backgroundSize = style.backgroundSize + ' ' + (
									setItem.bg.bgImg.height + 'px')
							} else {
								style.backgroundSize = style.backgroundSize + ' 100%'
							}
							if (setItem.bg.bgImg.type) {
								style.backgroundRepeat = setItem.bg.bgImg.type
							}
							if (setItem.bg.bgImg.position) {
								style.backgroundPosition = setItem.bg.bgImg.position
							}
							style.backgroundImage = backgroundImage
						}
						return style

					}
				} catch (e) {
					console.log('e', e)
				}
			},
			footBoxStyle() {
				if (this.equipment == 'phone') {
					return {}
				}
				try {
					if (this.all_setting.length > 0) {
						let setItem = this.all_setting[0].tabList[0].config.foot
						let style = {}
						if (setItem.bg.setWidth.type == 'px') {
							style.width = setItem.bg.setWidth.width + 'px'
						} else {
							style.width = "100%"
						}
						if (setItem.footerSetHeight.height) {
							// style.height = "none"
							// style.height = setItem.footerSetHeight.height + 'px'
						} else {
							// style.height = "none"
						}

						if (setItem.topShadow.bgColor) {
							style.boxShadow =
								`0px ${setItem.topShadow.y}px ${setItem.topShadow.r}px ${setItem.topShadow.bgColor} inset`
						}

						console.log('footBoxStylefootBoxStyle', style)
						return style
					}
				} catch (e) {
					console.log('e', e)
				}
			},

			cssStringToObject(cssString) {
				const styleObject = {};

				// 移除所有注释（可选）
				const cleanedCss = cssString.replace(/\/\*[\s\S]*?\*\//g, '');

				// 分割每条规则
				const rules = cleanedCss.split(';').filter(rule => rule.trim() !== '');

				rules.forEach(rule => {
					const [property, value] = rule.split(':').map(item => item
						.trim());
					if (property && value) {
						// 转换属性名为驼峰式（如 background-color -> backgroundColor）
						const camelCaseProperty = property.replace(/-([a-z])/g, (
							g) => g[1].toUpperCase());
						styleObject[camelCaseProperty] = value;
					}
				});

				return styleObject;
			},

			footBgBoxStyle() {
				try {
					if (this.all_setting.length > 0) {
						let setItem = this.all_setting[0].tabList[0].config.foot

						let style = {}
						if (setItem.bg.setWidth.type == 'px') {
							if (setItem.box.bgType == 'checked1') {
								style.background = setItem.box.boxSingleBgColor.bgColor
							}
							if (setItem.box.bgType == 'checked2') {
								style = {
									...style,
									...this.cssStringToObject(setItem.box.boxColor
										.bgColor)
								}
								// return 
							}
							if (setItem.box.bgType == 'checked3') {
								let backgroundImage = `url(${setItem.box.boxBgImg.url})`
								if (setItem.box.boxBgImg.width) {
									style.backgroundSize = setItem.box.boxBgImg.width +
										'px';
								} else {
									style.backgroundSize = '100%';
								}
								if (setItem.box.boxBgImg.height) {
									style.backgroundSize = style.backgroundSize + ' ' + (
										setItem.box.boxBgImg.height +
										'px')
								} else {
									style.backgroundSize = style.backgroundSize + ' 100%'
								}
								if (setItem.box.boxBgImg.type) {
									style.backgroundRepeat = setItem.box.boxBgImg.type
								}
								if (setItem.box.boxBgImg.position) {
									style.backgroundPosition = setItem.box.boxBgImg
										.position
								}
								style.backgroundImage = backgroundImage
							}
						}

						if (this.equipment == 'phone') {
							if (setItem.topShadow.bgColor) {
								style.boxShadow =
									`0px ${setItem.topShadow.y}px ${setItem.topShadow.r}px ${setItem.topShadow.bgColor} inset`
							}
						}
						console.log('footBgBoxStylefootBgBoxStylefootBgBoxStyle', style)
						return style
					}
				} catch (e) {
					console.log('e', e)
				}
			},

		}
	}
</script>

<style lang="scss" scoped>
	/* 可以设置不同的进入和离开动画 */
	/* 设置持续时间和动画函数 */
	.slide-fade-enter-active {
		transition: all .3s ease;
	}

	.slide-fade-leave-active {
		transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
	}

	.slide-fade-enter,
	.slide-fade-leave-to

	/* .slide-fade-leave-active for below version 2.1.8 */
		{
		transform: translateX(10px);
		opacity: 0;
	}


	/* 隐藏 Google 翻译控件 */
	#google_translate_element~div {
		display: none !important;
	}

	/* 防止页面跳动 */
	body {
		top: 0 !important;
	}

	.tit-icon:hover {
		color: '#fff'
	}

	.parent::before {
		content: "";
		position: absolute;
		width: 10000px;
		left: 50%;
		transform: translateX(-50%);
		height: 100%;
		background: #ff5500;
		z-index: -1;
	}

	.ellipsis {
		overflow: hidden;
		/* 隐藏溢出内容 */
		white-space: nowrap;
		/* 禁止换行 */
		text-overflow: ellipsis;
		/* 显示省略号 */
	}

	.el-breadcrumb {
		width: 100%;
		/* 或固定宽度 */
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.el-breadcrumb__item {
		display: inline-block;
		max-width: 50%;
		/* 可根据需要调整 */
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	// ::v-deep .tooltip__popper {
	// 	background-color: #fff;
	// 	color: #000;
	// }
</style>